var reward = {
    select: {
        init: function() {
            reward.select.handleChange();
            reward.select.handleBtn();
        },
        /**
         * Test reward options if values are selected and set error class
         * @returns {boolean} error - true if one is unset
         */
        checkOptions() {
            var error = false;
            $('.js-reward-option').each(function(i, e) {
                if ($(this).val()) {
                    $(this).
                        removeClass('mytyFormError').
                        closest('.mytyFormError').
                        removeClass('mytyFormError');
                } else {
                    $(this).
                        addClass('mytyFormError').
                        closest('.mytyFormBox').
                        addClass('mytyFormError');
                    error = true;
                }
            });
            return error;
        },
        handleChange() {
            $('form input').keydown(function(event) {
                if (event.keyCode == 13) {
                    $(this).blur();
                    // prevent submit by enter
                    event.preventDefault();
                    return false;
                } else if ($(this).closest('.mytyFormError').length) {
                    // remove error class
                    $(this).
                        removeClass('mytyFormError').
                        closest('.mytyFormError').
                        removeClass('mytyFormError');
                    reward.select.removeErrorMsg();
                }
            });
            $('.mytyFormCheckboxBox.mytyFormRequired input').
                change(function(event) {
                    // Fehler an Checkbox ggf. entfernen
                    if ($(this).prop('checked')) {
                        $(this).
                            add($(this).closest('.mytyFormCheckboxBox')).
                            removeClass('mytyFormError');
                    }
                });
            $('form select, .js-reward-option').change(function(event) {
                if ($(this).val()) {
                    $(this).
                        removeClass('mytyFormError').
                        closest('.mytyFormError').
                        removeClass('mytyFormError');
                }
                reward.select.removeErrorMsg();
            });
        },
        handleBtn() {
            $('.js-select-reward').click(function(event) {
                event.preventDefault();
                if (reward.select.checkOptions()) { // error case
                    $('.js-reward-error').show();
                } else {
                    reward.select.handleAmount($('.js-nr-input'),
                        $(this).attr('href'));
                }
            });
        },
        handleAmount(elem, fwdUrl) {
            var attr = elem.attr('amount'),
                id = elem.attr('data-id'),
                val = typeof attr !== 'undefined' && attr !== false ?
                    parseInt(elem.attr('amount')) :
                    parseInt(elem.val());
            //val = quantity of selected incentive
            //id = id of incentive or combined id with freeoptions
            projectPage.checkout.updateIncentiveToBasket(id, val, fwdUrl);
        },
        removeErrorMsg() {
            if (!$('.mytyFormError').length) {
                $('.js-checkout-error-msg').slideUp('fast');
                $('.js-reward-error').hide();
            }
        },
    },
    amount: {
        initCountSpinBtn: function() {
            $('.js-count-spinner').click(function(event) {
                event.preventDefault();
                var input = $(this).siblings('input'),
                    amount = parseFloat($(this).attr('data-amount'));
                input.val(parseFloat(input.val()) + amount);
                input.change();
                reward.amount.checkSpinBtn();
            });
            $('.js-nr-input').change(function(event) {
                reward.amount.checkAmount($(this));
                reward.amount.checkSpinBtn();
            });
            reward.amount.checkSpinBtn();
        },
        checkSpinBtn: function() {
            // +/- Buttons deaktivieren wenn Limit/Minimum erreicht
            $('.js-nr-input').each(function(index, element) {
                var plusBtn = $(this).
                        siblings('.js-count-spinner[data-amount="1"]'),
                    minusBtn = $(this).
                        siblings('.js-count-spinner[data-amount="-1"]'),
                    value = parseInt($(this).val());
                if (value >= parseInt($(this).attr('max'))) {
                    plusBtn.addClass('is-disabled');
                } else {
                    plusBtn.removeClass('is-disabled');
                }
                if (value <= parseInt($(this).attr('min'))) {
                    minusBtn.addClass('is-disabled');
                } else {
                    minusBtn.removeClass('is-disabled');
                }
            });
        },
        checkAmount(elem) {
            // min max check
            var amount = parseInt(elem.val()),
                min = parseInt(elem.attr('min')),
                max = parseInt(elem.attr('max'));
            if (isNaN(amount) || amount < min) {
                elem.val(min);
            } else if (amount > max) {
                elem.val(max);
            }
        },
    },
};

$(document).ready(function() {
    reward.amount.initCountSpinBtn();
    reward.select.init();
});
